<template>
	<div>
		<a-modal class="tutorReview" :title="Title" :visible="visible" @ok="handleOk" @cancel="handleCancel">
			
			<a-row>
				<a-col :span="10">
					<div style="display: flex;align-items: center;">
						<div>
							状态
						</div>
						<a-select v-model="state"  style="width: 120px;margin-left: 10px;" @change="handleChange">
						      <a-select-option value="true">
						        通过
						      </a-select-option>
							  <a-select-option value="false">
							    不通过
							  </a-select-option>
						</a-select>
					</div>
					
				</a-col>
				<!-- <a-col></a-col> -->
				<a-col :span="14">
					<div >
						<a-textarea v-model="remark" style="" placeholder="请填写审核说明" :rows="1" />
					</div>
				</a-col>
			</a-row>
		</a-modal>
	</div>
</template>

<script>
	import Qs from 'qs'
	import {TutorReview} from '@/api/index.js'
	export default {
		data() {
			return {
				visible: false,
				Title: '',
				data: [],
				remark:'',
				state:''
			};
		},
		methods: {
			showModal() {
				this.visible = true;
			},
			async handleOk(e) {
				console.log(this.$parent)
				
				const res = await TutorReview({AnimalExperimentId:this.data.animalExperimentId,State:this.state,Remarks:this.remark})
				console.log(res)
				if(res.data.state){
					this.visible = false;
					// this.$parent.getTableData('/Flat/SelAnimalExperiment', Qs.stringify({page:this.$parent.queryPage.current,limit:this.$parent.queryPage.pageSize,EthicalReviewForTeachId:this.$parent.searchNames==''?undefined:Number(this.$parent.searchNames),
					// beginDate:this.$parent.startTimes,
					// endDate:this.$parent.endTimes,
					// State:this.$parent.selectedState
					// }))
					
					this.$router.push({path:'/core/aniApplication'})
					this.$message.success('审核成功')
				}else{
					this.visible = false;
					this.$message.error(res.data.info)
				}
				
			},
			handleCancel(e) {
				this.visible = false;
			},
		},
		
	};
</script>

<style scoped>

</style>
<style>

</style>
